import { createSlice } from '@reduxjs/toolkit';
import { fetchPermissions } from './permissionThunk';

const permissionSlice = createSlice({
  name: 'permissionSlice',
  initialState: {
    permissions: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default permissionSlice.reducer;
